module.exports = __webpack_public_path__ + "img/bottlesClose.edc43776.jpg";